.fp-card
  .fp-icon-with-text
    img.fp-illustration.-md(:alt='name' :class='`-${illustration}`')
    .fp-icon-with-text--text
      .fp-icon-with-text--text-line
        h3.fp-title {{ t(`homepage.${translateKey}`) }}
      .fp-icon-with-text--text-line
        span.fp-text {{ t(`homepage.${translateKey}Description`) }}
